import { IsNotEmpty, IsUUID } from 'class-validator';

import { UploadLogoRequest } from '@app/gen/settings';

const notEmptyOptions = {
  message: 'Обязательное поле',
};

export class UploadLogoDto extends UploadLogoRequest {
  @IsNotEmpty(notEmptyOptions)
  @IsUUID()
  companyId: string;
}
